export const codeTemplates = [
  {
    id: 'blank',
    name: 'Blank Canvas',
    html: '<div class="custom-content">\n  <!-- Your HTML here -->\n</div>',
    css: '.custom-content {\n  /* Your CSS here */\n}'
  },
  {
    id: 'hero',
    name: 'Hero Section',
    html: `<div class="hero">
  <h1 class="hero-title">Build Something Amazing</h1>
  <p class="hero-subtitle">Create beautiful pages with custom HTML & CSS</p>
  <div class="hero-cta">
    <a href="#" class="btn btn-primary">Get Started</a>
    <a href="#" class="btn btn-secondary">Learn More</a>
  </div>
</div>`,
    css: `.hero {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.hero-subtitle {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.hero-cta {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn {
  padding: 0.75rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.2s;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn-primary {
  background: white;
  color: #667eea;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
}`
  },
  {
    id: 'pricing',
    name: 'Pricing Cards',
    html: `<div class="pricing-container">
  <div class="pricing-card">
    <h3>Starter</h3>
    <div class="price">$9<span>/mo</span></div>
    <ul class="features">
      <li>✓ 10 Projects</li>
      <li>✓ 5GB Storage</li>
      <li>✓ Email Support</li>
    </ul>
    <a href="#" class="pricing-btn">Choose Plan</a>
  </div>

  <div class="pricing-card featured">
    <div class="badge">Popular</div>
    <h3>Pro</h3>
    <div class="price">$29<span>/mo</span></div>
    <ul class="features">
      <li>✓ Unlimited Projects</li>
      <li>✓ 50GB Storage</li>
      <li>✓ Priority Support</li>
      <li>✓ Advanced Analytics</li>
    </ul>
    <a href="#" class="pricing-btn">Choose Plan</a>
  </div>

  <div class="pricing-card">
    <h3>Enterprise</h3>
    <div class="price">$99<span>/mo</span></div>
    <ul class="features">
      <li>✓ Unlimited Everything</li>
      <li>✓ 500GB Storage</li>
      <li>✓ 24/7 Support</li>
      <li>✓ Custom Integrations</li>
    </ul>
    <a href="#" class="pricing-btn">Choose Plan</a>
  </div>
</div>`,
    css: `.pricing-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.pricing-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  position: relative;
  transition: transform 0.3s, box-shadow 0.3s;
}

.pricing-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.pricing-card.featured {
  border-color: #667eea;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
}

.badge {
  position: absolute;
  top: -12px;
  right: 20px;
  background: #667eea;
  color: white;
  padding: 0.25rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
}

.pricing-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #1f2937;
}

.price {
  font-size: 3rem;
  font-weight: bold;
  color: #667eea;
  margin-bottom: 1.5rem;
}

.price span {
  font-size: 1rem;
  color: #6b7280;
}

.features {
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  text-align: left;
}

.features li {
  padding: 0.5rem 0;
  color: #4b5563;
}

.pricing-btn {
  display: block;
  width: 100%;
  padding: 0.75rem;
  background: #667eea;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: background 0.3s;
}

.pricing-btn:hover {
  background: #5568d3;
}`
  },
  {
    id: 'timeline',
    name: 'Timeline',
    html: `<div class="timeline">
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <h4>Founded</h4>
      <span class="timeline-date">2020</span>
      <p>Started our journey to revolutionize the industry</p>
    </div>
  </div>

  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <h4>Series A</h4>
      <span class="timeline-date">2021</span>
      <p>Raised $10M to scale our operations globally</p>
    </div>
  </div>

  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <h4>Product Launch</h4>
      <span class="timeline-date">2022</span>
      <p>Released our flagship product to 10,000+ users</p>
    </div>
  </div>

  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <h4>Going Global</h4>
      <span class="timeline-date">2023</span>
      <p>Expanded to 50 countries worldwide</p>
    </div>
  </div>
</div>`,
    css: `.timeline {
  position: relative;
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e5e7eb;
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  padding-left: 60px;
}

.timeline-dot {
  position: absolute;
  left: 11px;
  top: 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #667eea;
  border: 4px solid white;
  box-shadow: 0 0 0 2px #e5e7eb;
  z-index: 1;
}

.timeline-content {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.timeline-content h4 {
  margin: 0 0 0.5rem 0;
  color: #1f2937;
  font-size: 1.25rem;
}

.timeline-date {
  display: inline-block;
  background: #667eea;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.timeline-content p {
  margin: 0.75rem 0 0 0;
  color: #6b7280;
  line-height: 1.6;
}`
  }
];
